import * as React from 'react';
import config from 'config/config.ENV'; // eslint-disable-line
import branding from 'config/branding';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { injectGlobal, ThemeProvider } from 'styled-components';
import muiTheme from './muiTheme';
import styledReset from './styledReset';

injectGlobal`
  ${styledReset}
`;

export default Component =>
  class extends React.Component {
    // Remove the server-side injected CSS.
    componentDidMount() {
      const jssStyles = document.getElementById('jss-server-side');
      if (jssStyles && jssStyles.parentNode) {
        jssStyles.parentNode.removeChild(jssStyles);
      }
    }
    render() {
      return (
        <ThemeProvider theme={branding}>
          <MuiThemeProvider theme={muiTheme}>
            <Component {...this.props} />
          </MuiThemeProvider>
        </ThemeProvider>
      );
    }
  };



// WEBPACK FOOTER //
// /opt/build/repo/src/app/connectors/styling/styling.js